import React, {useEffect, useState} from "react";
import PhoneInputPckg from "react-phone-input-2";
import styles from './phoneInput.module.scss';

export default function PhoneInput({onChange, name, value, className = null, autoFocus = false}) {
  const [val, setValue] = useState(value);

  const onChang = (event) => {
    if (event.slice(0, 1) === '8') {
      event = event.slice(1, event.length)
      event += '7'
    }
    onChange({target: {value: event, name: name}})
  }

  useEffect(() => {
    setValue(value)
  }, [value])

  return (
    <PhoneInputPckg
      buttonStyle={{display: "none"}}
      inputClass={className ? className : styles.Inputs}
      specialLabel={''}
      value={val}
      country={'ru'}
      enableAreaCodes={true}
      enableTerritories={true}
      excludeCountries={[
        "tw",
        "vn",
        "kr",
        "kp",
        "mo",
        "la",
        "jp",
        "hk",
        "cn",
        "kh",
        "bd"
      ]}
      placeholder={'+7 (___) ___-__-__'}
      inputProps={{
        name: name,
        autoFocus: autoFocus
      }}
      onChange={onChang}
    />
  );
}